export default __webpack_public_path__ + "static/media/TV_Camara.3a4569ed.png";